import { UserActionsMenuItemConfig } from "../../../../../shared/components/topBarNewButtonMenu/TopBarNewButtonMenu"
import { createTopBarNewMenuItem } from "../../../../../shared/components/topBarNewButtonMenu/topBarNewMenuItems"
import { CreateOrderType } from "../../../../../shared/components/createOrder/helpers"
import { ModuleName } from "../../../../users/userTypes"

export type UserNewMenuSectionId = "booking" | "purchase"

type ModuleToItemFactory = Readonly<{
    moduleName: ModuleName
    section: UserNewMenuSectionId
    create: () => UserActionsMenuItemConfig
}>

export const moduleItemFactories = (
    params: Readonly<{
        handleCreateOrder: (type: CreateOrderType) => void
        handleOpenTakeaway: () => void
        handleOpenMakePurchase: () => void
        handleRefillWallet: () => void
    }>,
): ModuleToItemFactory[] => [
    {
        moduleName: ModuleName.BOOKING,
        section: "booking",
        create: () =>
            createTopBarNewMenuItem("resource-booking", () =>
                params.handleCreateOrder(CreateOrderType.RESOURCE_BOOKING),
            ),
    },
    {
        moduleName: ModuleName.CATERING,
        section: "booking",
        create: () =>
            createTopBarNewMenuItem("meeting-service", () => params.handleCreateOrder(CreateOrderType.MEETING_SERVICE)),
    },
    {
        moduleName: ModuleName.TAKE_AWAY,
        section: "purchase",
        create: () => createTopBarNewMenuItem("take-away", () => params.handleOpenTakeaway()),
    },
    // Hide for now as we don't make orders page for this
    // {
    //     moduleName: ModuleName.APP_PAYMENT,
    //     section: "purchase",
    //     create: () => createTopBarNewMenuItem("make-purchase", () => params.handleOpenMakePurchase()),
    // },
    {
        moduleName: ModuleName.REFILL_WALLET,
        section: "purchase",
        create: () =>
            createTopBarNewMenuItem("refill-wallet", () => {
                params.handleRefillWallet()
            }),
    },
]
